
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/global-buyer",
      function () {
        return require("private-next-pages/global-buyer/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/global-buyer"])
      });
    }
  